import { createAction, props } from '@ngrx/store';
import { PointInspection } from 'src/app/features/projet/models/point-inspection.model';

export enum PointInspectionActionTypes {
    SET_POINTS_INSPECTION_SUCCESS = `[PointsInspection] Set Points Inspection success`,
}

export const setPointsInspectionSuccess = createAction(PointInspectionActionTypes.SET_POINTS_INSPECTION_SUCCESS, props<{ pointsInspection: PointInspection[] }>());
